import editTour from './editTour.js';
import changeDayType from './changeDayType.js';
import addAssignment from './addAssignment.js';
import editAssignment from './editAssignment.js';
import addDayOffRequest from './addDayOffRequest.js';

const loadItemData = {
  editTour,
  changeDayType,
  addAssignment,
  editAssignment,
  addDayOffRequest
};

export default loadItemData;
